module.exports = __webpack_public_path__ + "static/img/GR@2x.ef151fe3.jpg";